export default async function load_packages() {
  const responseData = await this.api({
    url: "stripe/",
  });
  if (responseData.status === 200) {
    return responseData.body;
  } else {
    return [];
  }
}
